import api from "@/services/apiClient"
import GtmService, { UserFlow } from "@/services/gtmService"
import type StripePrice from "@/shared/enums/StripePrice"
import StripePaymentMethod from "@/shared/enums/StripePaymentMethod"

/**
 * Get the payment action for the given tier.
 *
 * @param stripePrice The stripe price that the checkout session should be created for.
 * @param userFlow The user flow that the payment is for.
 * @param beforeChangeUrl A function that is called before the url is changed. This is useful for cleanup.
 * @param discountIdentifier Optional discount/promo identifier to apply.
 * @param paymentMethods Provide payment methods if need to divert from default
 */
export default function getPaymentAction(
  stripePrices: StripePrice[],
  userFlow: UserFlow,
  beforeChangeUrl: () => void = () => {},
  discountIdentifier?: string,
  paymentMethods?: StripePaymentMethod[]
) {
  const action = async () => {
    await GtmService.addToCartEvent(userFlow)

    console.log("Creating checkout session")

    const checkoutSession = await api.stripe.postCheckoutSessionHosted({
      stripePrices,
      discountIdentifier,
      ...(paymentMethods && { paymentMethods })
    })

    if (!checkoutSession?.checkoutUrl) {
      throw new Error("Failed to create checkout session url")
    }

    // TODO: Move this event to when the user lands on the checkout page
    await GtmService.beginCheckoutEvent(userFlow, checkoutSession.items)

    beforeChangeUrl()

    // Open the checkout session in the same tab
    window.location.href = checkoutSession.checkoutUrl
  }

  return action
}
